import { render, staticRenderFns } from "./RegisterTeam.vue?vue&type=template&id=4fa8c47b&scoped=true&"
import script from "./RegisterTeam.vue?vue&type=script&lang=ts&"
export * from "./RegisterTeam.vue?vue&type=script&lang=ts&"
import style0 from "./RegisterTeam.vue?vue&type=style&index=0&id=4fa8c47b&prod&lang=scss&scoped=true&"
import style1 from "./RegisterTeam.vue?vue&type=style&index=1&id=4fa8c47b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa8c47b",
  null
  
)

export default component.exports